// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bodyRow__rUZFw:hover td {
  background: var(--tables-primary-row-surface-hover);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.bodyRow__rUZFw td {
  padding: 10px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  white-space: normal;
  font-size: 14px;
  line-height: 20px;
}
@media (max-width: 1300px) {
  .bodyRow__rUZFw td {
    padding: 10px 10px;
  }
}
@media (max-width: 1015px) {
  .bodyRow__rUZFw td {
    font-size: 12px;
    padding: 10px 5px;
  }
}

.ellipsisTextTwoLine__mlDs2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.facilityName__ngvle {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--tables-primary-row-text-additional);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
@media (max-width: 820px) {
  .facilityName__ngvle {
    width: 50px;
  }
}

.equipmentNameColumn__ybbjT {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
@media (max-width: 910px) {
  .equipmentNameColumn__ybbjT {
    width: 75px;
  }
}

.iconColumn__z5vMJ {
  cursor: pointer;
}

.expandRowIcon__lFVZa {
  outline: none;
  transition: all 0.3s ease-in-out;
}

.expandRowIconTop__dLKrZ {
  transform: rotate(180deg);
}

.skeletonText__QIN72 {
  height: 12px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/AssetHealthDetails/components/ExpandedRow/style.module.scss"],"names":[],"mappings":"AA2EE;EACE,mDAAA;EACA,yDAAA;AA1EJ;AA6EE;EACE,kBAAA;EACA,0CAAA;EACA,yDAAA;EACA,qDAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA3EJ;AA6EI;EATF;IAUI,kBAAA;EA1EJ;AACF;AA4EI;EAbF;IAcI,eAAA;IACA,iBAAA;EAzEJ;AACF;;AA6EA;EAnDE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAgDA,qBAAA;EACA,aAAA;AArEF;;AAwEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;EA7DA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EA2DA,qBAAA;EACA,aAAA;AAjEF;AAmEE;EAVF;IAWI,WAAA;EAhEF;AACF;;AAmEA;EAxEE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAqEA,qBAAA;EACA,aAAA;AA3DF;AA6DE;EALF;IAMI,WAAA;EA1DF;AACF;;AA6DA;EACE,eAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,gCAAA;AA1DF;;AA6DA;EACE,yBAAA;AA1DF;;AA6DA;EACE,YAAA;AA1DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.bodyRow {\n  &:hover td {\n    background: var(--tables-primary-row-surface-hover);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n  }\n\n  td {\n    padding: 10px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    white-space: normal;\n    font-size: 14px;\n    line-height: 20px;\n\n    @media (max-width: 1300px) {\n      padding: 10px 10px;\n    }\n\n    @media (max-width: 1015px) {\n      font-size: 12px;\n      padding: 10px 5px;\n    }\n  }\n}\n\n.ellipsisTextTwoLine {\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n}\n\n.facilityName {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--tables-primary-row-text-additional);\n\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n\n  @media (max-width: 820px) {\n    width: 50px;\n  }\n}\n\n.equipmentNameColumn {\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n\n  @media (max-width: 910px) {\n    width: 75px;\n  }\n}\n\n.iconColumn {\n  cursor: pointer;\n}\n\n.expandRowIcon {\n  outline: none;\n  transition: all 0.3s ease-in-out;\n}\n\n.expandRowIconTop {\n  transform: rotate(180deg);\n}\n\n.skeletonText {\n  height: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyRow": `bodyRow__rUZFw`,
	"ellipsisTextTwoLine": `ellipsisTextTwoLine__mlDs2`,
	"facilityName": `facilityName__ngvle`,
	"equipmentNameColumn": `equipmentNameColumn__ybbjT`,
	"iconColumn": `iconColumn__z5vMJ`,
	"expandRowIcon": `expandRowIcon__lFVZa`,
	"expandRowIconTop": `expandRowIconTop__dLKrZ`,
	"skeletonText": `skeletonText__QIN72`
};
module.exports = ___CSS_LOADER_EXPORT___;
